import React, {useState} from 'react'
import styled, {css} from "styled-components";
import CloseButton from "../DetailsModal/CloseButton";
import TextInput from "./TextInput";
// import Configurations from "./Configurations";
import SimpleCheckbox from "./SimpleCheckbox";
import {rem} from "polished";
import SimpleSelect from "./SimpleSelect";
import {validateEmail} from "../../helpers/utils";

const FormWrapper = styled.div`
  padding: 24px 16px;

  @media (min-width: 1024px) {
    padding: 40px 30px;
    border-left: 1px solid #E9E9E9;
  }
`
const FormTitle = styled.h2`
  font-size: 35px;
`

// TODO: Move this to separate component, cuz this style reused multiple times
const SubmitButton = styled.button`
  background: #CC6F4C;
  width: 100%;
  padding: ${rem(14)};
  border: 0;
  appearance: none;
  color: white;
  font-size: 20px;
  border-radius: 5px;
  cursor: pointer;
  font-family: sans-serif;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #231914;
  }

  &[disabled] {
    opacity: 0.2;
    cursor: not-allowed;
  }

  ${({outlined}) =>
          outlined &&
          css`
            background: white;
            color: #000;
            box-shadow: inset 0 0 0 2px #000;
          `}
  &:focus {
    outline: none;
  }
`;

const StyledSvg = styled.svg`
  margin-left: 8px;
`

const TextInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    font-family: "Roboto", sans-serif;
    margin: 15px 0;
    font-size: 17px;
  }
`

const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0 0 0;

  p {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
    color: #CC6F4C;
  }

  &[disabled] {
    display: none;
  }
`

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
`
const UpdateText = styled.p`
  margin-left: 10px;
  font-size: 12px;
  color: #939393;
  line-height: 1.2;
  font-family: "Roboto", sans-serif;
`

const Row = styled.div`
  margin-bottom: 20px;
`

const NameSurnameBlock = styled.div`
  display: grid;
  grid-gap: 20px;
  align-items: baseline;
  margin-bottom: 20px;
  grid-template-columns: repeat(2,minmax(0,1fr));
`

const Note = styled.p`
  color: #605D5C;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  margin: 20px 0;
  line-height: 1.5;

  span {
    font-weight: 700;
  }
`

const QuoteModalForm = ({closeModal, submitQuoteForm, screenShot}) => {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [postCode, setPostCode] = useState('');
    const [email, setEmail] = useState('');
    const [sendLink, setSendLink] = useState(true);
    const [phone, setPhone] = useState('');
    const [reference, setReference] = useState('')
    const [timescale, setTimescale] = useState('')
    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(false);
    const [successDisabled, setSuccessDisabled] = useState(true);
    const referenceOptions = [
        "Where did you hear about Royal Tubs?",
        "Google Search",
        "Instagram",
        "Facebook",
        "YouTube",
        "TikTok",
        "Pinterest",
        "Influencer",
        "Online Article/Blog",
        "Email/Newsletter",
        "Friend",
    ];
    const timescaleOptions = [
        "When would you like to receive your tub?",
        "Just looking for a quote",
        "As soon as possible",
        "1 - 2 weeks",
        "2 - 4 weeks",
        "1 - 2 months",
        "2 - 4 months",
        "4 - 6 months",
        "6+ months"
    ]

    const hasError = (name) => {
        return errors.includes(name)
    }

    const validateForm = () => {
        setErrors([])
        const errors = []

        if (!name) {
            errors.push('name')
        }

        if (!surname) {
            errors.push('surname')
        }

        if(!timescale) {
          errors.push('timescale')
        }

        if(!reference) {
          errors.push('reference')
        }

        if (!email) {
            errors.push('email')
        }

        if (email && !validateEmail(email)) {
            errors.push('validationEmail')
        }

        if (!postCode) {
            errors.push('postCode')
        }

        return errors
    }

    const submitForm = () => {
        const errors = validateForm()

        if (errors.length) {
            setErrors([...errors])
            return
        }

        setLoading(true)
        submitQuoteForm({
            name: `${name} ${surname}`,
            phone,
            email,
            postCode,
            sendLink,
            reference,
            timescale,
            screenShot: screenShot
        }).then(() => {
            //setLoading(false);
            setSuccessDisabled(false);
            //closeModal();
        })
    }

    return (
        <FormWrapper>
            <CloseButton closeModal={closeModal}/>
            <FormTitle>Request a Quote</FormTitle>
            {/*<Configurations title={title}/>*/}
            <TextInputsWrapper disabled={loading}>
              <Note>Enter your contact details to receive your customized hot tub and delivery quote via email.<br/><br/><span>* Required Fields</span></Note>
              <NameSurnameBlock>
                  <TextInput value={name} placeholder={"First Name *"} error={hasError("name")} onChange={setName}/>
                  <TextInput value={surname} placeholder={"Last Name *"} error={hasError("surname")}
                              onChange={setSurname}/>
              </NameSurnameBlock>
              <Row>
                  <TextInput value={email} placeholder={"Email Address *"} validationError={hasError('validationEmail')} error={hasError("email")} onChange={setEmail}/>
              </Row>
              <Row>
                  <TextInput value={phone} placeholder={"Phone Number"} onChange={setPhone}/>
              </Row>
              <CheckboxWrapper disabled={loading}>
                <SimpleCheckbox checked={sendLink}
                                onChange={setSendLink}/>
                <UpdateText>
                    I would like to be contacted regarding this quote
                </UpdateText>
            </CheckboxWrapper>
              <Row>
                  <TextInput value={postCode} placeholder={"Postcode *"} error={hasError("postCode")}
                              onChange={setPostCode}/>
              </Row>
              <Row>
                  <SimpleSelect options={timescaleOptions} onChange={setTimescale} error={hasError("timescale")} />
              </Row>
              <Row>
                  <SimpleSelect options={referenceOptions} onChange={setReference} error={hasError("reference")} />
              </Row>
            </TextInputsWrapper>

            <SubmitButton id="quote-form-submit" onClick={submitForm} disabled={loading}>Submit Request
                <StyledSvg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.81738 1.229C2.39551 0.807129 1.69238 0.760254 1.27051 1.229C0.801758 1.65088 0.754883 2.354 1.22363 2.82275L7.22363 9.15088L1.22363 15.479C0.754883 15.9478 0.801758 16.6509 1.27051 17.0728C1.69238 17.5415 2.39551 17.4946 2.81738 17.0728L9.56738 9.94775C9.80176 9.71338 9.89551 9.43213 9.89551 9.15088C9.89551 8.86963 9.80176 8.58838 9.56738 8.354L2.81738 1.229Z"
                        fill="white"/>
                </StyledSvg>
            </SubmitButton>

            

            <SuccessWrapper id="quote-form-success" disabled={successDisabled}>
              <p>Your request has been successfully submitted. We will get back to you via email shortly!</p> 
            </SuccessWrapper>
        </FormWrapper>
    )
}
export default QuoteModalForm;
